'use client';

import React, { useEffect } from 'react';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import SearchPageHeader from './search-page-header/search-page-header';
import SearchPageResults from './search-page-results/search-page-results';

export interface SearchProps {
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  searchPageInspirationalSearchEntryPoint?:
    | Content.Components['SearchPageInspirationalSearchEntryPoint']
    | null;
  /** Search settings for filters and search bar */
  searchSettings: Content.Components['SearchSettingsDto'];
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const Search = ({
  personalizationData,
  searchPageInspirationalSearchEntryPoint,
  searchSettings,
  trackingData,
}: SearchProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'search_result' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <SearchPageHeader searchSettings={searchSettings} />

      <SearchPageResults
        searchPageInspirationalSearchEntryPoint={
          searchPageInspirationalSearchEntryPoint
        }
        searchSettings={searchSettings}
      />
    </React.Fragment>
  );
};

Search.displayName = 'Search';

export default Search;
